import {extendsAPIServices} from "./APIServices"
import getEnv from "../../helpers/common/getEnv"
import {GET, POST} from "../../constants/HTTPConstants"

const baseAdminAPI = getEnv('baseAdminAPI')
const api = extendsAPIServices(baseAdminAPI)

export const _getListUsers = ({page = 1, limit = 100, query}) => {
    return api.makeAuthRequest({
        method: POST,
        url: '/users',
        data: {
            page,
            limit,
            query
        }
    })
}

export const _getListTeams = ({page = 1, limit = 100, query}) => {
    return api.makeAuthRequest({
        method: POST,
        url: '/teams',
        data: {
            page,
            limit,
            query
        }
    })
}

export const _switchUser = (userId) => {
    return api.makeAuthRequest({
        method: GET,
        url: `/switch-user?id=${userId}`
    })
}

export const _getUserDetail = (userId) => {
    return api.makeAuthRequest({
        method: GET,
        url: `/users/${userId}`
    })
}

export const _getTeamDetails = (teamId) => {
    return api.makeAuthRequest({
        method: GET,
        url: `/teams/${teamId}`
    })
}

export const _getUserSearchHistory = (userId) => {
    return api.makeAuthRequest({
        method: GET,
        url: `/users/${userId}/search-history`
    })
}

export const _getAvailableRoles = (userId) => {
    return api.makeAuthRequest({
        method: GET,
        url: `/users/roles/available`
    })
}

export const _updateUserRoles = (userId, roles = []) => {
    return api.makeAuthRequest({
        method: POST,
        url: `/users/${userId}/roles`,
        data: {
            roles
        }
    })
}



// WEBPACK FOOTER //
// ./src/services/apis/AdminServices.js